<template>
  <el-dialog
    v-loading="loading"
    class="o-dialog o-no-modal-bg o-dialog--sm o-dialog--md-70 o-dialog--lg-60 o-dialog--xl-50 o-dialog-h--85 o-resize-hieght"
    :title="readOnly ? '查看评估问题' : wtId ? '编辑评估问题' : '新增评估问题'"
    :visible.sync="dialogVisible"
    :modal="false"
    :close-on-click-modal="false"
    @close="$emit('close')"
  >
    <el-form
      ref="form"
      :model="form"
      :rules="rules"
      class="c-form"
      :inline="true"
      label-position="right"
      label-width="150px"
      label-suffix="："
    >
      <el-row class="c-form__row">
        <el-col
          class="c-form__col"
          :span="24"
        >
          <el-form-item
            class="c-form__item"
            label="具体位置"
            prop="jcwz"
          >
            <el-input
              v-model.trim="form.jcwz"
              class="c-form__input"
              :disabled="readOnly"
              maxlength="500"
            />
          </el-form-item>
        </el-col>
        <el-col
          class="c-form__col"
          :span="24"
        >
          <el-form-item
            class="c-form__item"
            label="问题描述"
            prop="wtms"
          >
            <el-input
              v-model.trim="form.wtms"
              class="c-form__input"
              :disabled="readOnly"
              type="textarea"
              :rows="3"
              maxlength="4000"
            />
          </el-form-item>
        </el-col>
        <el-col
          class="c-form__col"
          :span="24"
        >
          <el-form-item
            class="c-form__item"
            label="检查依据"
            prop="jcyj"
          >
            <el-input
              v-model.trim="form.jcyj"
              class="c-form__input"
              :disabled="readOnly"
              maxlength="1000"
            />
          </el-form-item>
        </el-col>
        <el-col
          class="c-form__col"
          :span="24"
        >
          <el-form-item
            class="c-form__item"
            label="风险说明"
          >
            <el-input
              v-model.trim="form.fxsm"
              class="c-form__input"
              :disabled="readOnly"
              type="textarea"
              :rows="2"
              maxlength="2000"
            />
          </el-form-item>
        </el-col>
        <el-col
          class="c-form__col"
          :span="24"
        >
          <el-form-item
            class="c-form__item"
            label="整改建议"
            prop="zgjy"
          >
            <el-input
              v-model.trim="form.zgjy"
              class="c-form__input"
              :disabled="readOnly"
              type="textarea"
              :rows="3"
              maxlength="4000"
            />
          </el-form-item>
        </el-col>
        <el-col
          class="c-form__col"
          :span="12"
        >
          <el-form-item
            class="c-form__item"
            label="当场整改情况"
            prop="dcgzgk"
          >
            <el-input
              v-model.trim="form.dcgzgk"
              class="c-form__input"
              :disabled="readOnly"
              type="textarea"
              :rows="2"
              maxlength="4000"
              placeholder="未当场整改可不填"
            />
          </el-form-item>
        </el-col>
        <el-col
          class="c-form__col"
          :span="12"
        >
          <el-form-item
            class="c-form__item"
            label="整改完成时间"
          >
            <el-date-picker
              v-model="form.dcgzsj"
              class="c-form__input"
              :disabled="readOnly"
              type="datetime"
              value-format="yyyy-MM-dd HH:mm:ss"
              placeholder="完成当场整改时必填"
            />
          </el-form-item>
        </el-col>
      </el-row>

      <el-divider content-position="left">
        问题证据
      </el-divider>
      <el-row class="c-form__row">
        <el-col
          class="c-form__col"
          :span="24"
        >
          <el-form-item
            class="c-form__item"
            label="附件"
          >
            <attachment-editor
              v-model="form.attachments"
              :types="issueAttachmentTypes"
              :read-only="readOnly"
              business-type="jxxfpgwt"
            />
            <div
              v-if="!readOnly"
              class="u-text-warning"
            >
              可分步补充问题和证据；资料不完整时不会计入已完成检查项，也不能生成正式报告。
            </div>
          </el-form-item>
        </el-col>
      </el-row>
    </el-form>

    <div
      slot="footer"
      class="o-dialog__footer"
    >
      <k-button
        v-if="!readOnly"
        btn-text="保存"
        :auth-type="true"
        type="primary"
        @click="save"
      />
      <k-button
        :btn-text="readOnly ? '关闭' : '取消'"
        :auth-type="false"
        @click="dialogVisible = false"
      />
    </div>
  </el-dialog>
</template>

<script>
import AttachmentEditor from './AttachmentEditor.vue';
import { pgIssueService } from './issue.service';

export default {
  name: 'JxxfPgIssueDialog',
  components: { AttachmentEditor },
  props: {
    visible: {
      type: Boolean,
      default: false
    },
    xmId: {
      type: String,
      required: true
    },
    wtId: {
      type: String,
      default: ''
    },
    readOnly: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      loading: false,
      dialogVisible: this.visible,
      form: this.emptyForm(),
      rules: {
        jcwz: [{ max: 500, message: '具体位置不能超过500个字符', trigger: 'blur' }],
        wtms: [{ max: 4000, message: '问题描述不能超过4000个字符', trigger: 'blur' }],
        jcyj: [{ max: 1000, message: '检查依据不能超过1000个字符', trigger: 'blur' }],
        fxsm: [{ max: 2000, message: '风险说明不能超过2000个字符', trigger: 'blur' }],
        zgjy: [{ max: 4000, message: '整改建议不能超过4000个字符', trigger: 'blur' }],
        dcgzgk: [{ validator: (rule, value, callback) => this.validateRepair(value, callback), trigger: 'blur' }]
      },
      issueAttachmentTypes: [
        { value: 'ZGQ', label: '整改前证据' },
        { value: 'ZGH', label: '整改后证据' },
        { value: 'QT', label: '其他资料' }
      ]
    };
  },
  methods: {
    emptyForm () {
      return {
        xmId: this.xmId,
        wtms: '',
        jcwz: '',
        jcyj: '',
        fxsm: '',
        zgjy: '',
        dcgzgk: '',
        dcgzsj: null,
        lockVersion: null,
        jcjlIds: [],
        attachments: []
      };
    },
    load () {
      this.loading = true;
      const request = this.wtId
        ? pgIssueService.detail(this.wtId)
        : Promise.resolve({ data: this.emptyForm() });
      request.then(result => {
        this.form = Object.assign(this.emptyForm(), result.data || {});
      }).finally(() => {
        this.loading = false;
      });
    },
    validateRepair (value, callback) {
      if (this.form.dcgzsj && !value) {
        callback(new Error('填写整改完成时间前，请先填写当场整改情况'));
        return;
      }
      callback();
    },
    save () {
      this.$refs.form.validate(valid => {
        if (!valid) return;
        this.loading = true;
        const request = this.wtId
          ? pgIssueService.update(this.wtId, this.form)
          : pgIssueService.create(this.form);
        request.then(rsp => {
          const savedWtId = this.wtId || (rsp.data && rsp.data.data);
          this.$message.success('问题保存成功');
          this.$emit('saved', savedWtId);
          this.dialogVisible = false;
        }).finally(() => {
          this.loading = false;
        });
      });
    }
  },
  watch: {
    visible (value) {
      this.dialogVisible = value;
      if (value) this.load();
    }
  },
  created () {
    if (this.visible) this.load();
  }
};
</script>

<style scoped lang="scss">
.el-date-editor,
.el-select {
  width: 100%;
}

::v-deep .jx-pg-attachments__row {
  flex-wrap: wrap;
}

::v-deep .jx-pg-attachments__name {
  min-width: 0;
}
</style>
